import React, { useEffect, useState } from 'react';
import { decodeStorage, encodeStorage } from '../../functions/storageBase64'
import { useHistory } from 'react-router-dom';
import './style.sass';

export default function HistorySearch({ ...props }) {
    const { sebusco, setTypeSearch } = props;

    var arrayBusquedas = decodeStorage('busquedas');
    const[deleteWorld, setDeleteWorld] = useState();
    const history = useHistory();
    const url = history.location.pathname;

    // si las busquedas estan vacias , vacia el storage
    if (arrayBusquedas === '') {
        encodeStorage('busquedas', []);
    }

    // Agrega las busquedas al storage para que se visualicen en todo el buscador
    useEffect(() => {
        if (sebusco != '') {
            if (arrayBusquedas.includes(String(sebusco))) {
                var indiceAeliminar = arrayBusquedas.indexOf(String(sebusco));
                arrayBusquedas.splice(indiceAeliminar, 1);
                arrayBusquedas.reverse().push(String(sebusco));
                encodeStorage('busquedas', arrayBusquedas);
            }
            else {
                if (arrayBusquedas.length < 31) {
                    arrayBusquedas.reverse().push(String(sebusco));
                    encodeStorage('busquedas', arrayBusquedas);
                }
                if (arrayBusquedas.length === 31) { 
                    var primero= arrayBusquedas.shift();
                    var indiceAeliminar1 = arrayBusquedas.indexOf(String(primero));
                    arrayBusquedas.splice(indiceAeliminar1, 1);
                    arrayBusquedas.push(String(sebusco));
                    encodeStorage('busquedas', arrayBusquedas);
                }
            }
        }
    }, [sebusco, deleteWorld])

    // elimina palabra al presionar el boton "x"
    const EliminarPalabra = (e) => {
        var indiceAeliminar = arrayBusquedas.indexOf(String(e.target.value));
        arrayBusquedas.splice(indiceAeliminar, 1);
        encodeStorage('busquedas', arrayBusquedas.reverse());
        setDeleteWorld(indiceAeliminar);
    }

    // agrega el valor de la palabra seleccionada en el input de busqueda
    const ReplicarEnBuscador = (e) => {
        e.preventDefault();
        var valor = String(e.target.value);
        setTypeSearch(valor);
    }

    // realiza la busqueda directamente con la palabra clave seleccionada
    function RealizarBusqueda(e) {
        var buscarTexto = String(e.target.id);
        setTypeSearch(buscarTexto);
        setTimeout(() => {
            history.replace(url, null);
            if(/Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ){
                window.location.href = `/resultados?query=${encodeURIComponent(buscarTexto)}`;
            }else{
                window.location.href = `/resultados?query=${encodeURIComponent(buscarTexto)}`;
            }
        }, 300);
    }

    return (
        <ul className="listaBusqueda">
            {arrayBusquedas &&
                arrayBusquedas.reverse().map((elemento, indice) =>

                    <li key={indice}>
                        <button className="cerrar" onClick={(e) => EliminarPalabra(e)} value={elemento} type="button">X</button>
                        <span onClick={(e) => RealizarBusqueda(e)} value={elemento} id={elemento}>{elemento}</span>
                        <button className="ir" onClick={(e) => ReplicarEnBuscador(e)} value={elemento}></button>
                    </li>

                )
            }
        </ul>
    )
}